import React, { Component, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { styled, useTheme } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LaunchIcon from '@mui/icons-material/Launch';
import ClearIcon from '@mui/icons-material/Clear';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import * as XXE from '../xxe/xxeclient/xxeclient.js';
import { UserInfo, netGet, netPost, netFetch, keycloak } from "../network";
import { ChooseDocumentUnitDialog } from "./document-runtime.js";

import { WorkflowInstance } from "../workflow/workflow";


function ChallengeResponsePanel (props) {
    const {
        document,
        id,
        propertyNode,
        open,
        onSave,
        onCancel,
        visible,
        ...other
    } = props;
    const [model, setModel] = useState([]);
    const [crmValue, setCrmValue] = useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);

    const crmMenuOpen = Boolean(anchorEl);

    // const [crmMenuOpen, setCrmMenuOpen] = useState(false);

    useEffect(() => {
        if ( document ) {
            netGet('/api/doc/qrh/crm/config/' + encodeURIComponent(document))
                .then(response => response.json())
                .then(config => {
                    
                    if ( Array.isArray(config) ) {
                        setModel(config);
                    }
                }).catch(error => {
                    console.log('Error fetching Document tree: ' + error);
                });
        }

    },[document]);

    useEffect(() => {
        if ( propertyNode?.attributes?.crm) {
            setCrmValue(propertyNode?.attributes?.crm);
        } else {
            setCrmValue('');
        }
    },[propertyNode]);

    useEffect(() => {
        if ( model ) {
            console.log('CRM model: ' + JSON.stringify(model));
        }
    },[model]);

    const save = (value) => {
        const v = value !== '' ? value : null;
        let propNode = {};
        if ( propertyNode ) {
            propNode = { ...propertyNode };
        }
        if ( !propNode.attributes ) {
            propNode['attributes'] = {};
        }
        propNode.attributes['crm'] = v;
        if ( typeof onSave === 'function') {
            onSave(propNode);
        }

    }

    const handleCrmClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCrmClose = () => {
        setAnchorEl(null);
    };

    const handleCrmMenuItemClick = (value) => {
        setAnchorEl(null);
        setCrmValue(value);
        save(value);
    }

    const handleClearClick = () => {
        setAnchorEl(null);
        setCrmValue('');
        save('');
    };

    return (
        <Box sx={{
            marginTop: 2, visibility: visible,
            position: 'absolute', width: '100%',
            fontSize: '92%'
        }}>
            <Box sx={{ display: 'flex', marginRight: 1, alignItems: 'baseline', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>Element:</Typography>
                <TextField defaultValue={propertyNode?.tag} variant="standard" slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontSize: 'inherit', width: '180px' }
                    },
                }} />
            </Box>
            {/* 
            <Box sx={{ display: 'flex', marginTop: 2, alignItems: 'baseline', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>ID:</Typography>
                <TextField readOnly defaultValue={propertyNode?.attributes?.id} variant="standard" slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontSize: '90%', width: '180px' }
                    },
                }} />
            </Box>
            */}
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', marginRight: 0, fontSize: 'inherit' }}>CRM:</Typography>
                <TextField value={crmValue}
                    variant="standard"
                    slotProps={{
                        input: {
                            readOnly: true,
                            sx: { fontSize: 'inherit', width: '180px', textAlign: 'center' },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title="Clear">
                                        <IconButton onClick={handleClearClick} sx={{ padding: 0, visibility: crmValue && crmValue !== '' ? 'visible' : 'hidden' }}><ClearIcon fontSize="small"/></IconButton>
                                    </Tooltip>
                                    <Tooltip title="Choose">
                                        <IconButton onClick={handleCrmClick}>
                                            <ArrowDropDownIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        },
                    }} />
                <Menu
                    id="crm-menu"
                    anchorEl={anchorEl}
                    open={crmMenuOpen}
                    onClose={handleCrmClose}
                    slotProps={{
                        list: {
                            'aria-labelledby': 'crm-menu',
                        },
                    }}
                >
                    {Array.isArray(model) && 
                        model.filter(i => i !== '').map( crmItem => {
                                // console.log('CRM item: ' + crmItem);
                                return (
                                    <MenuItem onClick={() => handleCrmMenuItemClick(crmItem)}>{crmItem}</MenuItem> 
                                );
                            } 
                        )
                    }
                </Menu>
            </Box>
            
        </Box>
    );
}

function GotoStepPanel (props) {
    const {
        editor,
        document,
        id,
        propertyNode,
        open,
        onSave,
        onCancel,
        visible,
        ...other
    } = props;
    const [model, setModel] = useState([]);
    const [linkendValue, setLinkendValue] = useState('');
    // const [crmMenuOpen, setCrmMenuOpen] = useState(false);

    useEffect(() => {
        if (document && editor && visible === 'visible' && propertyNode) {
            if (propertyNode?.attributes?.linkend) {
                setLinkendValue(propertyNode?.attributes?.linkend);
            } else {
                setLinkendValue('');
            }
            editor.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'qrh.getStepModel', 'ALL')
                .then(result => {
                    if (result?.value) {
                        try {
                            const stepList = JSON.parse(result.value);
                            if (Array.isArray(stepList)) {
                                setModel(stepList)
                            }
                        } catch (error) {
                            console.log('Error parsing step model: ' + error);
                        }
                    }

                });
        }

    },[document,editor,visible, propertyNode]);

    /*
    useEffect(() => {
        if ( propertyNode?.attributes?.linkend) {
            setLinkendValue(propertyNode?.attributes?.linkend);
        } else {
            setLinkendValue('');
        }
    },[propertyNode]);
    */

    /*
    useEffect(() => {
        if ( model ) {
            console.log('GotoStep model: ' + JSON.stringify(model));
        }
    },[model]);
    */

    const save = (value) => {
        const v = value !== '' ? value : null;
        let propNode = {};
        if ( propertyNode ) {
            propNode = { ...propertyNode };
        }
        if ( !propNode.attributes ) {
            propNode['attributes'] = {};
        }
        propNode.attributes['linkend'] = v;
        if ( typeof onSave === 'function') {
            onSave(propNode);
        }

    }

    const handleLinkendChange = (event) => {
        setLinkendValue(event.target.value);
        save(event.target.value);
    };

    const handleLinkendMenuItemClick = (value) => {
        setLinkendValue(value);
        save(value);
    };

    const handleClearClick = () => {
        setLinkendValue('');
        save('');
    };

    return (
        <Box sx={{
            marginTop: 2, visibility: visible,
            position: 'absolute', width: '100%',
            fontSize: '92%'
        }}>
            <Box sx={{ display: 'flex', marginRight: 1, alignItems: 'baseline', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>Element:</Typography>
                <TextField defaultValue={propertyNode?.tag} variant="standard" slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontSize: 'inherit', width: '180px' }
                    },
                }} />
            </Box>
            {/* 
            <Box sx={{ display: 'flex', marginTop: 2, alignItems: 'baseline', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>ID:</Typography>
                <TextField readOnly defaultValue={propertyNode?.attributes?.id} variant="standard" slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontSize: '90%', width: '180px' }
                    },
                }} />
            </Box>
            */}
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', marginRight: 0, fontSize: 'inherit' }}>Target:</Typography>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120, width: '100%'}}>
                    <Select
                        labelId="goto-target-label"
                        id="goto-target-select"
                        value={linkendValue}
                        onChange={handleLinkendChange}
                        label="Age"
                        sx={{width: '100%'}}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 200, // Set your desired max height in pixels or other units
                                },
                            },
                        }}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {Array.isArray(model) &&
                            model.map(item => {
                                // console.log('Target item: ' + JSON.stringify(item));
                                return (
                                    <MenuItem value={item.id}>{item.label}</MenuItem>
                                );
                            }
                            )
                        }
                    </Select>
                </FormControl>
            </Box>
            
        </Box>
    );
}

function GotoChecklistPanel (props) {
    const {
        workflowInstance,
        editor,
        document,
        id,
        propertyNode,
        open,
        onSave,
        onCancel,
        visible,
        ...other
    } = props;
    const [model, setModel] = useState([]);
    const [modelMap, setModelMap] = useState({});
    const [linkendValue, setLinkendValue] = useState('');
    const [previewValue, setPreviewValue] = useState('');
    // const [crmMenuOpen, setCrmMenuOpen] = useState(false);
    const [openChooseDocUnitDialog, setOpenChooseDocUnitDialog] = useState(false);

    const docUnitDialogTitle = 'Choose Checklist';

    useEffect(() => {
        if (document && editor && visible === 'visible' && propertyNode) {
            if (propertyNode?.attributes?.linkend) {
                setLinkendValue(propertyNode?.attributes?.linkend);
            } else {
                setLinkendValue('');
            }
            if ( propertyNode?.attributes?.preview ) {
                setPreviewValue(propertyNode.attributes.preview);
            } else {
                setPreviewValue('');
            }
            let url = '/api/doc/tree/' + encodeURIComponent(document) +
                '?target=QRH_CHECKLIST';
            // console.log('docUnit load ' + url);
            netGet(url)
                .then(response => response.json())
                .then(droot => {
                    if (droot) {
                        const m = [droot];
                        setModel(m);
                        const map = {};
                        loadModelMap(m, map);
                        if ( propertyNode.attributes?.linkend) {
                            const pnode = getNode(propertyNode.attributes.linkend, map);
                            if ( pnode ) {
                                setPreviewValue(pnode.label);
                            }
                        }
                        setModelMap(map);
                    }
                }).catch(error => {
                    console.log('Error fetching Document tree: ' + error);
                });
            /*
            editor.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'qrh.getStepModel', 'ALL')
                .then(result => {
                    if (result?.value) {
                        try {
                            const stepList = JSON.parse(result.value);
                            if (Array.isArray(stepList)) {
                                setModel(stepList)
                            }
                        } catch (error) {
                            console.log('Error parsing step model: ' + error);
                        }
                    }

                });
            */
        }

    },[document,editor,visible, propertyNode]);

    const findNode = (list, id) => {
        if ( Array.isArray(list) ) {
            const mnode = list.find( item => item.id = id);
            if ( mnode ) {
                return mnode;
            }
            let fnode;
            for(const item of list) {
                fnode = item.children ? findNode(item.children, id) : null;
                if ( fnode ) {
                    break;
                }
            }
            return fnode;
        }
        return null;
    };

    const loadModelMap = (list, map) => {
        if ( Array.isArray(list) ) {
            list.forEach(item => {
                if ( item.id ) {
                    map[item.id] = item;
                }
                if ( item.children ) {
                    loadModelMap(item.children, map);
                }
            })
        }
    };

    const getNode = (id, map = modelMap) => {
        if ( map ) {
            return map[id];
        }
        return null;
    };

    /*
    useEffect(() => {
        if ( propertyNode?.attributes?.linkend) {
            setLinkendValue(propertyNode?.attributes?.linkend);
        } else {
            setLinkendValue('');
        }
    },[propertyNode]);
    */

    /*
    useEffect(() => {
        if ( model ) {
            console.log('GotoStep model: ' + JSON.stringify(model));
        }
    },[model]);
    */
   
    const save = (value, preview) => {
        const v = value !== '' ? value : null;
        let propNode = {};
        if ( propertyNode ) {
            propNode = { ...propertyNode };
        }
        if ( !propNode.attributes ) {
            propNode['attributes'] = {};
        }
        propNode.attributes['linkend'] = v;
        if ( preview ) {
            propNode.attributes['preview'] = preview;
        }
        if ( typeof onSave === 'function') {
            onSave(propNode);
        }

    }

    const handleLinkendChange = (event) => {
        setLinkendValue(event.target.value);
        save(event.target.value);
    };

    const handleLinkendMenuItemClick = (value) => {
        setLinkendValue(value);
        save(value);
    };

    const handleClearClick = () => {
        setLinkendValue('');
        save('');
    };

    const handleChooserClick = () => {
        setOpenChooseDocUnitDialog(true);
    };

    const handleChooseDocUnitSave = (du) => {
        setOpenChooseDocUnitDialog(false);
        if ( du?.title ) {
            setPreviewValue(du.title);
        }
        if ( du?.id ) {
            setLinkendValue(du.id);
            save(du.id, du.title);
        }
    };

    return (
        <Box sx={{
            marginTop: 2, visibility: visible,
            position: 'absolute', width: '100%',
            fontSize: '92%'
        }}>
            <Box sx={{ display: 'flex', marginRight: 1, alignItems: 'baseline', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>Element:</Typography>
                <TextField defaultValue={propertyNode?.tag} variant="standard" slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontSize: 'inherit', width: '180px' }
                    },
                }} />
            </Box>
            {/* 
            <Box sx={{ display: 'flex', marginTop: 2, alignItems: 'baseline', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>ID:</Typography>
                <TextField readOnly defaultValue={propertyNode?.attributes?.id} variant="standard" slotProps={{
                    input: {
                        readOnly: true,
                        sx: { fontSize: '90%', width: '180px' }
                    },
                }} />
            </Box>
            */}
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
                <Typography sx={{ fontWeight: 'bold', width: '70px', marginRight: 0, fontSize: 'inherit' }}>Target:</Typography>
                <TextField value={previewValue}
                    variant="standard"
                    multiline
                    slotProps={{
                        input: {
                            readOnly: true,
                            sx: { fontSize: 'inherit', width: '180px', textAlign: 'center' },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title="Clear">
                                        <IconButton onClick={handleClearClick} sx={{ padding: 0, visibility: linkendValue && linkendValue !== '' ? 'visible' : 'hidden' }}><ClearIcon fontSize="small"/></IconButton>
                                    </Tooltip>
                                    <Tooltip title="Choose Checklist">
                                        <IconButton onClick={handleChooserClick} sx={{visibility: visible}}>
                                            <LaunchIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        },
                    }} />
            </Box>
            <ChooseDocumentUnitDialog open={openChooseDocUnitDialog} title={docUnitDialogTitle} instance={workflowInstance} document={document} 
                        onCancel={() => setOpenChooseDocUnitDialog(false)} target="QRH_CHECKLIST"
                        onSave={handleChooseDocUnitSave} />
        </Box>
    );
}

export {ChallengeResponsePanel, GotoStepPanel, GotoChecklistPanel};